"use client";
import React from 'react';
import { Car, Users2, ShieldCheck, LayoutGrid as Home } from 'lucide-react';

const stats = [
    { label: "Dealerships", value: "1200+", icon: Home },
    { label: "Vehicles Managed", value: "1.2M", icon: Car },
    { label: "Active Users", value: "100K+", icon: Users2 },
    { label: "Uptime", value: "99.9%", icon: ShieldCheck }
];

const brands = [
    { name: "Toyota", logo: "/images/brands/1.png" },
    { name: "BMW", logo: "/images/brands/2.png" },
    { name: "Audi", logo: "/images/brands/3.png" },
    { name: "Honda", logo: "/images/brands/5.png" },
    { name: "Ather", logo: "/images/brands/6.png" },
    { name: "TVS", logo: "/images/brands/7.png" },
];

const TrustSection = () => {
    return (
        <section className="py-16 md:py-24 bg-slate-900 relative overflow-hidden">
            {/* Background Decorative Glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand/10 via-transparent to-transparent opacity-50 pointer-events-none" />

            <div className="container mx-auto px-6 md:px-12 lg:px-24 relative z-10">

                {/* Stats Cards: Responsive grid 1 -> 2 -> 4 columns */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-16 md:mb-28">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className="relative group p-6 md:p-8 rounded-[1.5rem] md:rounded-[2rem] bg-white/5 border border-white/10 hover:border-brand/50 hover:bg-white/[0.07] transition-all duration-500"
                        >
                            <div className="flex items-center lg:flex-col lg:text-center gap-5 md:gap-4">
                                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl md:rounded-2xl bg-brand/20 flex items-center justify-center text-brand group-hover:scale-110 group-hover:bg-brand group-hover:text-white transition-all duration-500 shadow-[0_0_20px_rgba(var(--brand-rgb),0.3)] shrink-0">
                                    <stat.icon size={24} className="md:w-7 md:h-7" />
                                </div>

                                <div>
                                    <h4 className="text-2xl md:text-4xl font-black text-white tracking-tighter">
                                        {stat.value}
                                    </h4>
                                    <p className="text-slate-400 font-bold tracking-widest text-[15px] mt-1">
                                        {stat.label}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Logo Cloud Section */}
                <div className="rounded-[2.5rem] md:rounded-[4rem] bg-white border border-white/10 p-8 md:p-12 lg:p-16">
                    <div className="text-center mb-12 md:mb-16">
                        <h2 className="text-black text-lg md:text-3xl font-black px-4 tracking-[0.15em] md:tracking-[0.2em] opacity-80">
                            Trusted by Global Automotive Leaders
                        </h2>
                        <div className="h-1.5 w-16 md:w-24 bg-brand mx-auto mt-6 rounded-full shadow-[0_0_15px_rgba(var(--brand-rgb),0.6)]" />
                    </div>

                    {/* Logo Container: 
                        - flex-wrap + justify-center handles mobile layout
                        - md:flex-nowrap + justify-center keeps them in one line on desktop
                    */}
                    <div className="flex flex-wrap md:flex-nowrap justify-center items-center gap-6 md:gap-10 lg:gap-14">
                        {brands.map((brand, i) => (
                            <div key={i} className="group flex-shrink-0">
                                <img
                                    src={brand.logo}
                                    alt={brand.name}
                                    className="h-8 sm:h-10 md:h-14 lg:h-16 w-auto object-contain opacity-80 grayscale transition-all duration-700 ease-out group-hover:opacity-100 group-hover:grayscale-0 group-hover:brightness-100 group-hover:scale-110"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustSection;